import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Shop } from "../models/shop.model";
import { AlertService } from "./alert.service";
import { AuthService } from "./auth.service";
import { EndpointFactoryService } from "./endpoint-factory.service";

@Injectable()
export class ShopEndpointService extends EndpointFactoryService {

  protected URL: string = "/api/Shop";

  constructor(http: HttpClient, alertService: AlertService, authService: AuthService) {
    super(http, alertService, authService);

  }

  public getAllShops(showError: boolean = true): Observable<Shop[]> {
    return this.getAuthorizedWithErrorHandling(this.URL, () => this.getAllShops(showError), null, showError);
  }

  public get(id: string, showError: boolean = true): Observable<Shop> {
    return this.getAuthorizedWithErrorHandling(this.URL + id, () => this.get(id, showError), null, showError);
  }

}
